export const ERROR_TYPES = {
    NOT_ELIGIBLE: 'NOT_ELIGIBLE' as const,
    ALREADY_OPTED: 'ALREADY_OPTED' as const,
    UNDERAGE: 'UNDERAGE' as const,
    SOMETHING_WRONG: 'SOMETHING_WRONG' as const,
    ERROR_MAINTENANCE: 'ERROR_MAINTENANCE' as const
};

const TYPE_PER_CODES = {
    [ERROR_TYPES.ALREADY_OPTED]: ['POST:4003'],
    [ERROR_TYPES.NOT_ELIGIBLE]: ['GET:1007', 'POST:5003'],
    [ERROR_TYPES.UNDERAGE]: ['GET:1008', 'POST:1008'],
    [ERROR_TYPES.SOMETHING_WRONG]: [
        'GET:1006',
        'GET:5001',
        'POST:1007',
        'POST:3001',
        'POST:2001',
        'POST:5007',
        'POST:4002',
        'POST:5002',
        'POST:5001'
    ]
};

/*
* @params codePerType typeof CODE_PER_TYPE
* @returns { [code]: [type] }
*/
export function insideOut(typePerCodes: Record<string, Array<number | string>>): Record<string, string> {
    return Object.entries(typePerCodes)
        .map(([type, codes]) => codes.reduce((codeAcc, code) => ({ ...codeAcc, [code]: type }), {}))
        .reduce((acc, codesToType) => ({ ...acc, ...codesToType }), {});
}

export const ERROR_CODE_PER_TYPE = insideOut(TYPE_PER_CODES);
